var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"loading-mask"},[_c('div',{staticClass:"loading-spinner"}),_c('div',{},[_vm._v("下载中...")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }